module.exports = __webpack_public_path__ + "img/yisheng.74b292c5.svg";